// Дизайн-токены блога. Преемственность с лендингом: ink + orange, без indigo/violet из мокапа.
// Структура editorial: uppercase mono eyebrow «§ 01 · ...», 1-пиксельные сетки границ, paper фон.

export const BT = {
    ink: '#0b1020',
    paper: '#ffffff',
    panel: '#f5f0e8',
    warm: '#e8e4db',
    rule: 'rgba(11,16,32,0.10)',
    sub: 'rgba(11,16,32,0.70)',
    subDim: 'rgba(11,16,32,0.55)',
    accent: '#ea580c',
    accent2: '#db2777',
    accentSoft: 'rgba(234,88,12,0.08)',
    fontHead: 'var(--font-unbounded), Unbounded, Manrope, Inter, sans-serif',
    fontSub: 'var(--font-manrope), Manrope, Inter, sans-serif',
    fontBody: 'var(--font-inter), Inter, system-ui, sans-serif',
    fontMono: 'var(--font-jetbrains), "JetBrains Mono", ui-monospace, Menlo, monospace',
} as const

export const labelStyle: React.CSSProperties = {
    fontFamily: BT.fontMono,
    fontSize: 11,
    letterSpacing: 1.2,
    textTransform: 'uppercase',
    color: BT.subDim,
}
